import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title || "The Saraogi Clothing Company"}</title>
      <meta
        name="description"
        content={description || "The Saraogi Clothing Company"}
      />
      <meta name="keywords" content={keywords || "The Saraogi Clothing Company"} />
    </Helmet>
  );
};

export default SeoHelmet;
